export default {
  deposit: {
    crypto: 'क्रिप्टो',
    fiatOrCash: 'फ़िएट/नकद',
    depositCurrency: 'जमा मुद्रा',
    chooseNetwork: 'नेटवर्क चुनें',
    depositAddress: 'जमा पता',
    copy: 'कॉपी करें',
    copied: 'कॉपी हो गया!',
    close: 'बंद करें',
    more: 'और',
    select: 'चुनें',
    channel: 'चैनल',
    loading: 'लोड हो रहा है...',
    noCurrency: 'कोई मुद्रा उपलब्ध नहीं',
    bonusTip: 'अपने पहले रिचार्ज पर जमा बोनस का आनंद लें, 200% तक अतिरिक्त क्रेडिट के साथ।',
    minDeposit: 'न्यूनतम जमा',
    sendOnly: 'इस जमा पते पर केवल {currency} भेजें। {confirmations} नेटवर्क पुष्टिकरण के बाद सिक्के स्वचालित रूप से जमा हो जाएंगे।',
    depositAmount: 'जमा राशि',
    enterAmount: 'राशि दर्ज करें',
    confirmDeposit: 'जमा की पुष्टि करें',
    depositTitle: 'जमा',
    selectChannel: 'चैनल चुनें',
    subtitle: 'तेज़, सुरक्षित और सुविधाजनक',
    secureEncrypted: 'सुरक्षित और एन्क्रिप्टेड',
    terms: 'आगे बढ़ने पर, आप हमारे नियम और शर्तों से सहमत होते हैं',
    totalDepositAmount: 'कुल जमा राशि',
    fee: 'शुल्क',
    arrivalAmount: 'जमा की गई राशि',
    payMethod: 'Payment Method',
    cpf: 'CPF',
    enterCpf: 'Please enter your CPF',
    depositSuccess: 'जमा सफल!',
    depositFailed: 'जमा विफल, कृपया पुनः प्रयास करें।',
    mockArrive: 'नकली आगमन (परीक्षण)',
    activity: {
      firstChargeTitle: 'पहली रिचार्ज पंजीकरण इवेंट',
      firstChargeSubtitle: 'विशेष पुरस्कार पाने के लिए अपना पहला जमा पंजीकृत करें',
      dailyThreeTitle: 'दैनिक तीन रिचार्ज',
      dailyThreeSubtitle: 'अतिरिक्त बोनस पाने के लिए रोज़ाना 3 जमा पूरे करें',
      dailyPreviewLabel: 'पहली रिचार्ज पुरस्कार',
      upTo: '{amount} {unit} तक',
      safeTitle: 'आपका धन हमारे पास सुरक्षित है',
      safeDesc: 'हम आपके लेन-देन और व्यक्तिगत जानकारी की सुरक्षा के लिए उद्योग-अग्रणी सुरक्षा का उपयोग करते हैं।',
      dailyFirst: 'दैनिक पहला रिचार्ज',
      dailySecond: 'दैनिक दूसरा रिचार्ज',
      dailyThird: 'दैनिक तीसरा रिचार्ज',
      lossReward: 'हानि वापसी',
      lossRewardSubtitle: 'अपनी हानि पर कैशबैक पाएं',
      rebateUpTo: '{ratio}% तक वापसी',
      notEligible: 'आप अब इस गतिविधि में भाग नहीं ले सकते',
      lossNeedSelect: 'कैशबैक में शामिल होने के लिए जमा करते समय यह गतिविधि चुनें',
      claimed: 'प्राप्त किया',
      claim: 'प्राप्त करें',
      noTier: 'कोई स्तर नहीं',
      claimWillOpen: '{time} पर प्राप्ति शुरू होगी',
      claimTimeNotReached: 'प्राप्ति का समय अभी नहीं हुआ। कृपया {time} के बाद वापस आएं।',
      bonus: 'बोनस',
      rebate: 'वापसी',
      depositGE: 'जमा ≥ {amount}',
      lossGE: 'हानि ≥ {amount}',
      claimSuccess: 'सफलतापूर्वक प्राप्त किया',
      claimFailed: 'प्राप्ति विफल',
      alreadyClaimed: 'आप पहले ही इस स्तर को प्राप्त कर चुके हैं। दोबारा क्लिक न करें।',
      lossAlreadyClaimed: 'आप पहले ही इस स्तर की हानि वापसी प्राप्त कर चुके हैं। दोबारा क्लिक न करें।',
      requireLogin: 'प्राप्त करने से पहले लॉगिन करें।',
      depositNotEnough: 'आपकी जमा राशि अभी मानदंड पूरा नहीं करती। प्रयास जारी रखें!',
      lossNotEnough: 'कल की हानि राशि मानदंड पूरा नहीं करती।',
      onlyHighest: 'यह गतिविधि पुरस्कार केवल उच्चतम स्तर पर ही प्राप्त किया जा सकता है।',
    },
  },
};
